import { query, mutation } from '@/services/graphql';
import * as operations from './operations';

export default {
  getCourseUnitList(variables = {}) {
    return query(operations.COURSE_UNIT_LIST, variables, true);
  },
  getCourseModulelList(variables = {}) {
    return query(operations.COURSE_MODULE_LIST, variables, false, { showErrorMessage: false });
  },
  getCourseData(variables = {}) {
    return query(operations.COURSE_DATA, variables, true);
  },
  submitCourseResult(variables = {}) {
    return mutation(operations.COURSE_RESULT, variables, true);
  },
};
